<template>
  <div
    class="breakdown-selector"
    :class="{
      open: open,
      disabled: disabled,
      'is-wrapped': isWrapped,
      'is-loading': isLoading,
    }"
  >
    <dropdown-select
      v-model="value"
      :multiple="false"
      :options="options"
      :disabled="disabled || isLoading"
      :label-parser="literal"
      :class="{ 'is-wrapped': isWrapped }"
      @open="open = true"
      @close="open = false"
    />
  </div>
</template>

<script>
import DropdownSelect from './DropdownSelect.vue'

export default {
  components: { DropdownSelect },
  props: ['id', 'name', 'options', 'selected', 'disabled', 'isWrapped', 'isLoading'],
  data() {
    return {
      open: false,
    }
  },
  computed: {
    value: {
      get() {
        return this.selected
      },
      set(val) {
        const wrapper = {}
        wrapper[this.id] = val[0]
        this.$emit('update', wrapper)
      },
    },
    flip() {
      return this.$store.state.query.flip
    },
    flipLiteral() {
      return this.flip ? 'Revert flip' : 'Set as items on chart'
    },
  },
  methods: {
    literal() {
      const label = this.$lng(this.value.labels[this.lng], this.id)
      const name = this.$lng(this.name, this.id)
      return `<label>${name}:</label>
      <span class="value">${label}</span>`
    },
  },
}
</script>

<style lang="stylus">
.breakdown-selector
  cursor: pointer
  flex: 1 1 0%
  position: relative

  +m-breakpoint(sm md)
    max-width: 90vw

  &.disabled:not(.is-wrapped)
    cursor: default
    max-width: 90vw

  &.open
    .dropdown-select__label
      border-bottom: none

  &.is-loading::after 
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 10
    cursor: progress
    background-color: transparent
    content: ""

  .dropdown-select__label
    align-items: center
    display: flex
    border-bottom: 1px solid $gray

    > label
      margin-right: 0.5em
      font-size: 0.85em
      line-height: 1.25

      .mobile &
        margin-right: 0.1em

        +m-breakpoint(landscape)
          margin-right: 0.5em

      .mobile &
        +m-breakpoint(landscape)
          font-size: .8em

    > .value
      m-ellipsis(100%)
      margin-right: 0.5em
      margin-top: 0.15em
      font-size: 0.85em
      line-height: 1.75

      .mobile &
        +m-breakpoint(landscape)
          font-size: .8em
</style>
